import React from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { getRolesListPath, ROLES_PATH } from './constants';
import { BackButton, BackButtonWrap } from './styles';
import { RoleCategory } from './types';

interface BackToRolesProps {
  roleCategory?: RoleCategory;
}

export function BackToRoles({ roleCategory }: BackToRolesProps) {
  const navigate = useNavigate();
  const rolesPath = roleCategory ? getRolesListPath(roleCategory) : ROLES_PATH;

  return (
    <BackButtonWrap>
      <BackButton
        color="primary"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(rolesPath)}
      >
        BACK
      </BackButton>
    </BackButtonWrap>
  );
}
